export enum MessageDeliveryChannelEnum {
  None = 0, 
  Email = 1,
  SMS = 2,
}
